import Task from "../task";
import {toMomentDate} from "../../../gd/convert/moment-date";
import {ScheduleStatus} from "../../../gd/types/types";


// const debug = "taskAutoUpdateScheduleDate"
const debug = false

/// based on start / end

export function taskAutoUpdateScheduleDate(task:Task) {   // , newScheduleDate:Moment|null, isNewTask?:boolean

    debug && console.log(debug,"() autoScheduleUpdatedTasks=", gd.company.settings.labs.planning.autoScheduleUpdatedTasks)

    // Action redquired
    if (!task.actionRequiredUserId) {
        debug && console.log(debug, "no AR case")
        if (task.scheduleDate) {
            task.updateSchedule(null, ScheduleStatus.NOT_SCHEDULED)
        }

        return
    }

    if (task.isNewlyCreated) {
        debug && console.log(debug, "new taskcase")
        // if disabled - do nothing
        if (!gd.company.settings.labs.planning.autoScheduleNewTasks) {
            return
        }

        // autoset schedule date for new tasks
        if (!task.scheduleDate && task.startDate) {

            const newScheduleDate = task.startDate.isBefore(moment()) ? momentDate() : toMomentDate(task.startDate)
            task.updateSchedule(newScheduleDate, ScheduleStatus.SCHEDULED)
        }

        return
    }


    // update case
    if (gd.company.settings.labs.planning.autoScheduleUpdatedTasks) {
        debug && console.log(debug, "update case")
        if (!task.scheduleDate || task.scheduleDate.isBefore(task.startDate, 'day') || task.scheduleDate.isAfter(task.endDate, 'day')) {
            let newScheduleDate : Moment

            //if start date is before today -> today else startDate
            if (task.startDate && task.startDate.isBefore(moment())) {
                newScheduleDate = momentDate(); // today
            } else {
                newScheduleDate = toMomentDate(task.startDate)!
            }

            task.updateSchedule(newScheduleDate, ScheduleStatus.SCHEDULED)
        }

        return
    }


    // do nothing
    return


}